import { Archive, GitBranch, Images, Shield, type LucideIcon } from "lucide-react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { cn } from "../lib/utils";
import { Button } from "@/components/ui/button";

export function PublicLayout() {
  const location = useLocation();
  const isExplore = location.pathname === "/" || location.pathname.startsWith("/grades/");
  const isGraph = isExplore && new URLSearchParams(location.search).get("view") === "graph";
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="sticky top-0 z-30 border-b bg-white/95 backdrop-blur">
        <div className="page-shell flex min-h-16 items-center justify-between gap-4">
          <Link to="/" className="flex min-w-0 items-center gap-3 text-ink">
            <span className="flex size-10 shrink-0 items-center justify-center rounded-2xl bg-ink text-white">
              <Archive size={20} aria-hidden="true" />
            </span>
            <span className="min-w-0">
              <span className="block truncate text-base font-semibold">社团成员档案</span>
              <span className="block truncate text-xs text-muted-foreground">影像与关系索引</span>
            </span>
          </Link>

          <nav className="hidden items-center gap-2 md:flex" aria-label="公共导航">
            <Button asChild variant="ghost" className="rounded-full text-muted-foreground">
              <Link to="/admin">
                <Shield size={16} aria-hidden="true" />
                后台
              </Link>
            </Button>
          </nav>
        </div>
      </header>

      <main className="pb-20 md:pb-0">
        <Outlet />
      </main>

      <nav
        className="fixed inset-x-3 bottom-3 z-40 grid grid-cols-3 rounded-full border bg-white/95 p-1 shadow-card backdrop-blur md:hidden"
        aria-label="移动端导航"
      >
        <MobileNavItem to="/" active={isExplore && !isGraph} icon={Images} label="影像" />
        <MobileNavItem to="/?view=graph" active={isGraph} icon={GitBranch} label="图谱" />
        <MobileNavItem to="/admin" active={isAdmin} icon={Shield} label="后台" />
      </nav>
    </div>
  );
}

function MobileNavItem({
  to,
  active,
  icon: Icon,
  label,
}: {
  to: string;
  active: boolean;
  icon: LucideIcon;
  label: string;
}) {
  return (
    <Link
      to={to}
      className={cn(
        "flex min-h-12 flex-col items-center justify-center rounded-full text-[11px] font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        active ? "bg-ink text-white" : "text-muted-foreground hover:bg-soft hover:text-ink",
      )}
    >
      <Icon size={17} aria-hidden="true" />
      <span className="mt-0.5">{label}</span>
    </Link>
  );
}
